import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Popover, Link } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { usePurchaseHistoryContext } from '../../hooks/useContexts';
import { pushEventInfo } from '../../utils/analytics';
export var MissingPurchase = function () {
    var _a;
    var _b = usePurchaseHistoryContext(), orderHistoryLoaded = _b.orderHistoryLoaded, orderHistoryData = _b.orderHistoryData, setOpenAddReceiptDrawer = _b.setOpenAddReceiptDrawer, customerType = _b.customerType;
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    var navigate = useNavigate();
    var totalNumberOfOrders = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.itemsCount) || 0;
    var getTooltipMessage = function () {
        if (customerType === 'b2b') {
            return (React.createElement(Typography, { variant: "body-base" },
                "Only purchases made with a registered card or added in-store receipts will show in Purchase History. Add a registered card to your",
                ' ',
                React.createElement(Link, { onClick: function () { return navigate('/myaccount/payments'); } }, "Cards & Accounts"),
                ", or",
                ' ',
                React.createElement(Link, { onClick: function () { return setOpenAddReceiptDrawer(true); } }, "Add a Receipt"),
                ' ',
                "to see in-store purchases."));
        }
        return (React.createElement(Typography, { variant: "body-base" },
            "Only purchases made with a registered card will show in Purchase History. Add a registered card to your",
            ' ',
            React.createElement(Link, { onClick: function () { return navigate('/myaccount/payments'); } }, "Cards & Accounts"),
            "."));
    };
    if (orderHistoryLoaded &&
        (totalNumberOfOrders !== 0 || ((_a = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _a === void 0 ? void 0 : _a.length) !== 0)) {
        return (React.createElement("div", { className: "sui-flex sui-gap-[7px]" },
            React.createElement(Typography, null, "Don't see a purchase?"),
            React.createElement(InfoFilled, { style: { marginTop: '4px', cursor: 'pointer' }, size: "small", color: "info", "aria-describedby": id, onClick: function (event) {
                    pushEventInfo({
                        category: { primaryCategory: 'button submission' },
                        eventInfo: { eventName: 'my account settings' },
                        myAccount: {
                            settings: 'purchase history: dont see a purchase tooltip',
                        },
                    });
                    setAnchorEl(event.currentTarget);
                } }),
            React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, placement: "bottom", title: "Missing Purchases", offset: "loose" },
                React.createElement("div", { className: "sui-w-[252px]" }, getTooltipMessage()))));
    }
    return null;
};
